import { render, staticRenderFns } from "./EventForm.vue?vue&type=template&id=27284d16&scoped=true&lang=pug"
import script from "./EventForm.vue?vue&type=script&lang=js"
export * from "./EventForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27284d16",
  null
  
)

export default component.exports